/*
 * Design trial 4 (rebuild-16): motion that answers the user.
 * On a "Visit [Maker]'s shop" button click, the words become "Opening [Maker]'s shop…" for 600 ms,
 * so the tap is confirmed while the maker's site opens in a new tab. The link, its tracking
 * (assets/dte-outbound.js) and its destination are untouched. The button keeps its width, so
 * nothing shifts. No library. Loaded only while trial 4 is on (snippets/dte-head.liquid).
 */
(function () {
  var MS = 600;
  var me = document.currentScript;
  var tpl = (me && me.getAttribute('data-opening')) || 'Opening [shop]…';
  var tplShort = (me && me.getAttribute('data-opening-short')) || 'Opening the shop…';

  function labelSpan(a) {
    for (var i = 0; i < a.children.length; i++) {
      var c = a.children[i];
      if (c.tagName === 'SPAN' && !c.classList.contains('visually-hidden')) return c;
    }
    return null;
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a.dte-visit.dte-button[data-dte-outbound]') : null;
    if (!a || a.classList.contains('is-opening')) return;
    var span = labelSpan(a);
    if (!span) return;
    var before = span.textContent;
    var m = /^\s*Visit\s+(.+?)\s*$/.exec(before);
    if (!m) return;
    var box = a.getBoundingClientRect();
    a.style.minWidth = box.width + 'px';
    a.classList.add('is-opening');
    // Longest words that still fit on the button's own lines, so its height never changes:
    // "Opening Pemberton Honey Co's shop…", then "Opening Pemberton Honey Co…", then "Opening the shop…".
    var shop = m[1];
    var name = shop.replace(/['’]s?\s+shop$/i, '');
    var tries = [tpl.replace('[shop]', shop), tpl.replace('[shop]', name).replace(/\s*…$/, '…'), tplShort];
    for (var i = 0; i < tries.length; i++) {
      span.textContent = tries[i];
      if (a.getBoundingClientRect().height <= box.height + 0.5) break;
    }
    setTimeout(function () {
      span.textContent = before;
      a.classList.remove('is-opening');
      a.style.minWidth = '';
    }, MS);
  });
})();
